// extracted by mini-css-extract-plugin
export default {"pagination":"AP-z","pageSize":"BP-z","disabled":"CP-z","pageGroups":"DP-z","pageGroup":"EP-z","currentPage":"FP-z","previousPage":"GP-z","nextPage":"HP-z"};